import logo from '@/assets/images/logo.webp';
import { cx } from '@/cva.config';

interface PeekingGoblinProps {
  caption?: string;
  className?: string;
}

export const PeekingGoblin = ({
  caption = 'Nothing here yet.',
  className,
}: PeekingGoblinProps) => (
  <div className={cx('flex flex-col items-center gap-4 py-12', className)}>
    <div className="relative flex size-32 items-center justify-center">
      <div className="absolute inset-0 rounded-full bg-radial from-accent-soft to-transparent to-65%" />
      <div className="relative size-28 overflow-hidden">
        <img
          alt=""
          className="-ml-41.5 h-28 w-69.5 max-w-none object-cover object-right drop-shadow-[0_8px_16px_rgba(0,0,0,.4)]"
          src={logo}
        />
      </div>
    </div>
    <p className="max-w-xs text-center font-mono text-xs text-balance text-foreground-muted">
      {caption}
    </p>
  </div>
);
